import React from 'react'
import {
  Box,
  DisplayPosition,
  AlignItems,
  JustifyContent,
  ZIndex,
  Icon,
} from '@gousto-internal/citrus-react'

type ScrollArrowProps = {
  direction: 'left' | 'right'
  onClick: () => void
}

export const ScrollArrow = ({ direction, onClick }: ScrollArrowProps) => (
  <Box
    position={DisplayPosition.Absolute}
    display="flex"
    alignItems={AlignItems.Center}
    justifyContent={JustifyContent.Center}
    width="40px"
    zIndex={ZIndex.Top}
    height="100%"
    left={direction === 'left' ? '0' : undefined}
    right={direction === 'right' ? '0' : undefined}
    top="0"
    bottom="0"
    style={{
      cursor: 'pointer',
      background: `linear-gradient(to ${direction}, rgba(255,255,255,0) 0%, rgba(244, 247, 250,1) 100%)`,
    }}
    onClick={onClick}
  >
    <Icon name={`chevron_${direction}`} />
  </Box>
)
